import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { FcFlashOn } from 'react-icons/fc';
import { Crown, Star } from 'lucide-react';

import MarketingPrice from '../../MarketingPrice/MarketingPrice';
import ListingPhotos from '../ListingPhotos';
import WishListIcon from '../../WishListIcon';
import VideoPreview from '../../VideoPreview';

import messages from '../../../locale/messages';
import { formatURL } from '../../../helpers/formatURL';

import steeringIcon from '/public/SiteIcons/steeringIcon.svg';
import startIcon from '/public/SiteIcons/star.svg';
import arrowIcon from '/public/SiteIcons/rentNowArrow.svg';

// Use same CSS as HomeSlider (new design)
import s from '../../Home/HomeSlider/HomeSlider.css';
import cs from '../../commonStyle.css';

class ListingItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false,
      currentSlide: 0
    };
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
  }

  handleImageMouseEnter = () => {
    this.setState({ isHovering: true });
  }

  handleImageMouseLeave = () => {
    this.setState({ isHovering: false });
  }

  handleSlideChange = (slideIndex) => {
    this.setState({ currentSlide: slideIndex });
  }

  static propTypes = {
    id: PropTypes.number,
    basePrice: PropTypes.number,
    hourPrice: PropTypes.number,
    currency: PropTypes.string,
    title: PropTypes.string,
    carType: PropTypes.string,
    listPhotos: PropTypes.array,
    coverPhoto: PropTypes.number,
    bookingType: PropTypes.string,
    bookingMode: PropTypes.string,
    reviewsCount: PropTypes.number,
    reviewsStarRating: PropTypes.number,
    wishListStatus: PropTypes.bool,
    isListOwner: PropTypes.bool,
    transmission: PropTypes.string,
    isFeatured: PropTypes.bool,
    featuredTier: PropTypes.string,
    youtubeVideoId: PropTypes.string,
    categoryType: PropTypes.string,
    personCapacity: PropTypes.number,
    bedrooms: PropTypes.number
  };

  handleMouseOver(value) {
    const { change } = this.props;
    change('SearchForm', 'markerHighlight', { 'id': value, 'hover': 'true' });
  }

  handleMouseOut(value) {
    const { change } = this.props;
    change('SearchForm', 'markerHighlight', {});
  }

  render() {
    const { formatMessage } = this.props.intl;
    const {
      id,
      basePrice,
      hourPrice,
      currency,
      title,
      carType,
      coverPhoto,
      listPhotos,
      bookingType,
      bookingMode,
      reviewsCount,
      reviewsStarRating,
      wishListStatus,
      isListOwner,
      transmission,
      personalized,
      isFeatured,
      featuredTier,
      youtubeVideoId,
      categoryType,
      personCapacity,
      bedrooms
    } = this.props;

    let starRatingValue = 0;
    if (reviewsCount > 0 && reviewsStarRating > 0) {
      starRatingValue = Math.round(reviewsStarRating / reviewsCount);
    }

    const transmissionLabel = transmission == '1' ? formatMessage(messages.Automatic) : formatMessage(messages.Manuall);

    // Determine category for display
    const category = categoryType || 'boat';

    // Build info line based on category
    let infoLine = '';
    if (category === 'boat') {
      infoLine = carType ? `${carType} • ${transmissionLabel}` : transmissionLabel;
    } else if (category === 'posada') {
      infoLine = bedrooms ? `${bedrooms} hab. • ${personCapacity || 0} huespedes` : `${personCapacity || 0} huespedes`;
    } else if (category === 'experience') {
      infoLine = `${personCapacity || 0} participantes`;
    }

    let personalizeURL = '';
    if (personalized?.location && personalized?.startDate && personalized?.endDate) {
      personalizeURL = `?&address=${personalized.location}&startdate=${personalized.startDate}&enddate=${personalized.endDate}`;
    } else if (personalized?.location) {
      personalizeURL = `?&address=${personalized.location}`;
    } else if (personalized?.startDate) {
      personalizeURL = `?&startdate=${personalized.startDate}${personalized?.endDate ? '&enddate=' + personalized.endDate : ''}`;
    }

    const isPremium = featuredTier === 'premium';

    return (
      <div onMouseOver={() => this.handleMouseOver(id)} onMouseOut={() => this.handleMouseOut(id)}>
        <div className={s.boxShadowmain}>
          <div
            style={{ position: 'relative' }}
            onMouseEnter={this.handleImageMouseEnter}
            onMouseLeave={this.handleImageMouseLeave}
          >
            {!isListOwner && <WishListIcon listId={id} key={id} isChecked={wishListStatus} />}
            {isFeatured && (
              <div className={isPremium ? s.featuredBadgePremium : s.featuredBadge}>
                <span>{isPremium ? <><Crown size={14} /> Premium</> : <><Star size={14} /> Destacado</>}</span>
              </div>
            )}
            <ListingPhotos
              id={id}
              listPhotos={listPhotos}
              coverPhoto={coverPhoto}
              formatURL={formatURL}
              title={title}
              personalizeURL={personalizeURL}
              onSlideChange={this.handleSlideChange}
            />
            {youtubeVideoId && this.state.currentSlide === 0 && (
              <VideoPreview
                youtubeUrl={youtubeVideoId}
                thumbnailUrl={listPhotos && listPhotos.length > 0 ? `/images/upload/x_medium_${(listPhotos.find(p => p.id === coverPhoto) || listPhotos[0])?.name?.replace(/\.(jpe?g|png)$/i, '.webp')}` : ''}
                alt={title}
                isOverlay={true}
                isHovering={this.state.isHovering}
              />
            )}
          </div>
          <a
            href={"/boats/" + formatURL(title) + '-' + id + personalizeURL}
            target={'_blank'}
            className={cs.textDecorationNone}
          >
            <div className={s.boxShadow}>
              <div className={s.PerDayWrap}></div>
              <div className={s.sliderbackground}>
                <div className={cx(s.HRDetails, 'HRDetailsRTL')}>
                  <div className={cx(s.trip, s.hiddentextSlider, 'hiddentextSliderRTL')}>
                    <img src={steeringIcon} className={cx(s.carType, 'carTypeIconRTL')} />
                    <span className='carTypeRTL'>{infoLine}</span>
                  </div>
                </div>
                <div className={cx(s.flex)}>
                  {/* per/hour - show if bookingMode is 'hourly' or 'both' or undefined */}
                  {(bookingMode === 'hourly' || bookingMode === 'both' || !bookingMode) && hourPrice > 0 && (
                    <div className={cx(s.PerDay)}>
                      {bookingType === "instant" && <span><FcFlashOn className={s.instantIcon} /></span>}
                      <MarketingPrice amount={hourPrice} from={currency} />
                      <span className={cx(s.perNightCss, 'PerDayRTL')}>{' '}{formatMessage(messages.perHour)}</span>
                    </div>
                  )}
                  {/* per/day - show if bookingMode is 'daily' or 'both' or undefined */}
                  {(bookingMode === 'daily' || bookingMode === 'both' || !bookingMode) && (
                    <div className={cx(s.PerDay)}>
                      {bookingType === "instant" && <span><FcFlashOn className={s.instantIcon} /></span>}
                      <MarketingPrice amount={basePrice} from={currency} />
                      <span className={cx(s.perNightCss, 'PerDayRTL')}>{' '}{formatMessage(messages.perNight)}</span>
                    </div>
                  )}
                </div>
                <h3 className={s.titleCss}>{title}</h3>
                <div className={s.HRRight}>
                  {starRatingValue > 0 && <div className={cx(s.reviewCss, 'reviewCssSliderRTL')}>
                    <img src={startIcon} className={cx(s.reviewCssImg, 'reviewCssImgRTL')} /><span>{starRatingValue}</span>
                  </div>}
                  <span className={cx(s.btn, cs.textDecorationNone)}>
                    <span className={cs.vtrMiddle}><FormattedMessage {...messages.rentNowText} /></span>
                    <img src={arrowIcon} className={cx(s.arrowIconCss, 'sliderArrowRTL')} />
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  personalized: state?.personalized
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(ListingItem)));
